module.exports = __webpack_public_path__ + "img/SL7_4735-Bearbeitet.173ea0eb.jpg";